<template>
  <div>
    <div />
  </div>
</template>

<script>
export default {
  name: 'VbShipping',
  components: {},
}
</script>
